export const resourceAttributeDictionary = { 
    createdByUserId: {
        header: "Created by (id)",
        visible: false,
        renderType: "text"
    },
    createdByUserName: {
        header: "Created by",
        visible: true,
        renderType: "text"
    },
    createdDateTime: {
        header: "Created on",
        visible: true,
        renderType: "datetime"
    },
    projectId: {
        header: 'Project Id',
        visible: false,
        renderType: 'text',
    }, 
    fileName: {
        header: 'File name',
        visible: false,
        renderType: 'text',
    },
    fileStatus: {
        header: 'File status',
        visible: false,
        renderType: 'text',
    },
    id: {
        header: 'Id',
        visible: false,
        renderType: 'text',
    },
    modifiedByUserName: {
        header: 'Modified by',
        visible: true,
        renderType: 'text',
    },
    modifiedDateTime: {
        header: 'Modified on',
        visible: true,
        renderType: 'datetime',
    },
    name: {
        header: 'Description',
        visible: true,
        renderType: 'text',
    },
    workspaceId: {
        header: 'Project Id',
        visible: false,
        renderType: 'text',
    },    
}


// WEBPACK FOOTER //
// ./src/utilities/resourceDictionary.js